import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { FeeActions, NotificationActions } from '../../../store';
import { formatFeeNumber } from '../../../utils';


const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})


const feeSelector = (state) => state.Fees;
const IdentitySelector = (state) => state.Identity;

const FeeManagementDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const feeActions = bindActionCreators(FeeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting, list } = useSelector(feeSelector);
    const { token, permissions } = useSelector(IdentitySelector);

    const { classes, data } = props;


    if (!editing) {
        //const { prevEditing } = useSelector(feeSelector);
    }
    else {
        //console.log(editing);
    }

    const onBackClick = () => {
        props.onCancel();
    }

    const onDeleteClick = () => {
        // この手数料設定を削除します
        feeActions.delete(token, editing)
            .then(data => {
                notificationActions.showSuccess('削除しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });

//        console.log('delete clicked');
    }

    const onEdit = (data) => {
        //props.onEdit(e.currentTarget.id);
        //go to fee management update page 
        props.onEdit(data);
    }

    var editButton = <div></div>;
    var deleteButton = <div></div>;

    // 手数料管理の編集権限チェック
    if (editing && list &&
        permissions.fid5_7 != null && (permissions.fid5_7.value.value & 2) == 2) {
        var today = new Date().toISOString().slice(0, 10);
        var maxSeq = list.filter(fee => fee.id == editing.id).reduce((a, b) => a.seq > b.seq ? a : b).seq;
        var editDisabled = (editing.start_date <= today) || editing.seq == 1 || editing.seq != maxSeq;
        var deleteDisabled = (editing.start_date <= today) || editing.seq == 1 || editing.seq != maxSeq;

        editButton =
            <div>
                <Button fullWidth variant="contained" size="medium" color="primary"
                    onClick={() => onEdit(editing)}
                    disabled={editDisabled}
                    endIcon={<EditIcon />}>
                    <FormattedMessage id="Button.Edit" />
                </Button>
            </div>;

        deleteButton =
            <Button fullWidth variant="contained" size="medium" color="primary"
                onClick={onDeleteClick}
                disabled={deleteDisabled}
                endIcon={<DeleteForeverIcon />}><FormattedMessage id="Button.Delete" /></Button>
    }

    var ShopModeKey = 'Merchant.GeneralStore';
    if (editing && editing.credit_card_payment_agency_id) {
        if (editing.credit_card_payment_agency_id == '100002') {
            ShopModeKey = 'Merchant.GeneralStore';
        }
        else if (editing.credit_card_payment_agency_id == '100003') {
            ShopModeKey = 'Merchant.Taxi';
        }
        else if (editing.credit_card_payment_agency_id == '100004') {
            ShopModeKey = 'Merchant.Retail';
        }
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="FeeManagement.FeeSettingDetails" />}</Typography>
                    </Grid>
                </Grid>
                <Grid container className={classes.form} spacing={2} >
                    <Grid item xs={12}>
                        <div className={classes.infoTitle}>
                            <Typography id="infoTitle" component="h1" variant="inherit">{<FormattedMessage id="FeeManagement.FeeInformation" />}</Typography>
                            {editButton}
                        </div>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"FeeManagement.MerchantName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Period"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.period}</InputLabel>
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFeeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardPayment"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.system_fee_okica_card_payment)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.brand_fee_okica_card_payment)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.QRBalanceSettlement"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.system_fee_qr_payment)}%</InputLabel>
                    </Grid>

                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.brand_fee_qr_payment)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={5}>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.ChargeCommissionRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardCharge"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.merchant_fee_okica_card_charge)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardValue"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.merchant_fee_okica_card_value_exchange)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={5}>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend" id="bank-payment-agency-id-label"><FormattedMessage id={"Merchant.Shop"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend"><FormattedMessage id={ShopModeKey} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CreditFeeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFee"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.system_fee_credit_card_payment)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.brand_fee_credit_card_payment)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={5}>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFee"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.system_fee_bank_payment)}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{formatFeeNumber(editing.brand_fee_bank_payment)}%</InputLabel>
                    </Grid>

                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                    <Grid item xs={6}>
                        {deleteButton}
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(FeeManagementDetail);
